import React from 'react';
import { motion } from 'framer-motion';
import { Choice } from '../../types/story';

interface ChoiceButtonProps {
  choice: Choice;
  onSelect: (choiceId: string) => void;
  disabled?: boolean;
  index?: number;
}

export const ChoiceButton: React.FC<ChoiceButtonProps> = ({
  choice,
  onSelect,
  disabled = false,
  index = 0
}) => {
  const handleClick = () => {
    if (!disabled) {
      onSelect(choice.id);
    }
  };

  return (
    <motion.button
      initial={{ opacity: 0, x: -20 }}
      animate={{ opacity: 1, x: 0 }}
      transition={{ delay: index * 0.1 }}
      whileHover={{ scale: 1.02 }}
      whileTap={{ scale: 0.98 }}
      onClick={handleClick}
      disabled={disabled}
      className={`
        w-full text-left p-4 rounded-xl transition-all duration-200
        ${disabled
          ? 'bg-gray-100 text-gray-400 cursor-not-allowed'
          : 'bg-white hover:bg-blue-50 border-2 border-gray-200 hover:border-blue-300 hover:shadow-md cursor-pointer'
        }
      `}
    >
      <div className="flex items-start">
        <span className="text-blue-600 font-bold mr-3">{String.fromCharCode(65 + index)}.</span>
        <span className="text-gray-800">{choice.text}</span>
      </div>
      {choice.effects && (
        <div className="mt-2 text-xs text-gray-500">
          {choice.effects.trustChange && (
            <span className="mr-3">
              信任度 {choice.effects.trustChange > 0 ? '+' : ''}{choice.effects.trustChange}
            </span>
          )}
          {choice.effects.unlockEvidence && (
            <span className="mr-3">🔍 解锁证据</span>
          )}
          {choice.effects.addNote && (
            <span>📝 添加笔记</span>
          )}
        </div>
      )}
    </motion.button>
  );
};